import { API } from 'src/api/API';

export const useDeleteUser = () => {
    const _delete = async (id: number) => {
        return new API().deleteUser(id);
    };

    return [_delete] as const;
};
